import axios from 'axios'

export const state = {
  groups: null,
}

export const getters = {
  groups: (state) => state.groups,
  groupOptions: (state) =>
    state.groups &&
    state.groups.map(({ title, city }) => ({ id: title, label: title, city })),
}

export const mutations = {
  SET_GROUPS(state, groups) {
    state.groups = groups
  },
}

export const actions = {
  fetchAllGroups({ commit }) {
    return axios.get('/api/groups').then((response) => {
      const groups = response.data
      commit('SET_GROUPS', groups)
      return groups
    })
  },
}
